import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {
  Filter,
  Labeled,
  SearchInput,
  SelectInput,
  Title,
  useDataProvider,
} from "react-admin";
import { Helmet } from "react-helmet";
import "../dashboard.scss";
import SanitizedGrid from "components/SanitizedGrid";
import {
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Tabs,
  Tab,
  Typography,
} from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InvoiceTable from "pages/commercialDocuments/components/InvoiceTable";
import TabPanel from "pages/routeplans/components/TabPanel";
import moment from "moment";
import { paymentStatusFilterList } from "pages/parents/conts";
import PaymentHistoryTable from "pages/parents/components/PaymentHistoryTable";
import FindInvoiceNumberInput from "./FindInvoiceNumberInput";

const useStyles = makeStyles({
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
  marginFilter: {
    minWidth: "200px",
    marginBottom: "20px",
  },
});

const DashboardFinance = () => {
  const [yearFilter, setYearFilter] = useState("");
  const [fromDateFilter, setFromDateFilter] = useState<string>(null);
  const [toDateFilter, setToDateFilter] = useState<string>(null);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [valueDashboardTab, setValueDashboardTab] = React.useState(0);
  const [totalReceived, setTotalReceived] = useState(0);
  const [totalOutstanding, setTotalOutstanding] = useState(0);
  const classes = useStyles();
  const provider = useDataProvider();

  const handleChangeDashboardTab = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setValueDashboardTab(newValue);
  };

  const GetAmount = () => {
    provider.customGetOne("accountSummaries").then(({ data }: any) => {
      setTotalReceived(data.totalPaid);
      setTotalOutstanding(data.totalOutstanding);
    });
  };

  useEffect(() => {
    GetAmount();
  }, []);

  const dashboardProps = (index: number) => {
    return {
      id: `dashboard-tab-${index}`,
      "aria-controls": `dashboard-tabpanel-${index}`,
    };
  };

  const filterMonth = (filterSet: string) => {
    var filterDate = new Date();
    var nowDate = new Date();
    if (filterSet === "Last 3 Month") {
      setFromDateFilter(
        moment(filterDate.setMonth(filterDate.getMonth() - 3)).format(
          "YYYY-MM-DD"
        )
      );
      setToDateFilter(moment(nowDate).format("YYYY-MM-DD"));
    } else if (filterSet === "Last 6 Month") {
      setFromDateFilter(
        moment(filterDate.setMonth(filterDate.getMonth() - 6)).format(
          "YYYY-MM-DD"
        )
      );
      setToDateFilter(moment(nowDate).format("YYYY-MM-DD"));
    } else if (filterSet === "Last 1 Year") {
      setFromDateFilter(
        moment(filterDate.setMonth(filterDate.getMonth() - 12)).format(
          "YYYY-MM-DD"
        )
      );
      setToDateFilter(moment(nowDate).format("YYYY-MM-DD"));
    } else if (filterSet === "CustomRange") {
      setFromDateFilter(moment(fromDate).format("YYYY-MM-DD"));
      setToDateFilter(moment(toDate).format("YYYY-MM-DD"));
    } else {
      setFromDateFilter(null);
      setToDateFilter(null);
    }
  };

  return (
    <div>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <SanitizedGrid container spacing={5} style={{ marginTop: "8px" }}>
            <Grid item xs={3}>
              <Card className="cardColor">
                <CardContent
                  style={{ justifyContent: "center", display: "flex" }}
                >
                  <Labeled label="Total Received">
                    <div>{`$ ${(totalReceived / 100).toLocaleString()}`}</div>
                  </Labeled>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={3}>
              <Card className="cardColor">
                <CardContent
                  style={{ justifyContent: "center", display: "flex" }}
                >
                  <Labeled label="Total Outstanding">
                    <div>{`$ ${(
                      totalOutstanding / 100
                    ).toLocaleString()}`}</div>
                  </Labeled>
                </CardContent>
              </Card>
            </Grid>
          </SanitizedGrid>
        </Grid>

        <SanitizedGrid container spacing={2} style={{ marginTop: "15px" }}>
          <Grid item className={classes.marginFilter}>
            <Card>
              <CardContent>
                <FormControl fullWidth>
                  <InputLabel>Filter</InputLabel>
                  <Select
                    displayEmpty
                    value={yearFilter}
                    label="Age"
                    onChange={(e) => {
                      setYearFilter(e.target.value.toString());
                      filterMonth(e.target.value.toString());
                    }}
                  >
                    <MenuItem value={""}></MenuItem>
                    <MenuItem value={"Last 3 Month"}>Last 3 Month</MenuItem>
                    <MenuItem value={"Last 6 Month"}>Last 6 Month</MenuItem>
                    <MenuItem value={"Last 1 Year"}>Last 1 Year</MenuItem>
                    <MenuItem value={"CustomRange"}>Custom Range</MenuItem>
                  </Select>
                </FormControl>
                {yearFilter === "CustomRange" && (
                  <Grid container>
                    <Grid item xs={5}>
                      <Card>
                        <CardContent>
                          <Labeled label="From Date ">
                            <div></div>
                          </Labeled>
                          <DatePicker
                            selected={fromDate}
                            onChange={(date: Date) => {
                              setFromDateFilter(
                                moment(date).format("YYYY-MM-DD")
                              );
                              setFromDate(date);
                            }}
                            dateFormat="MMMM d, yyyy"
                            maxDate={new Date()}
                            className="customDate"
                          />
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={5}>
                      <Card>
                        <CardContent>
                          <Labeled label="To Date ">
                            <div></div>
                          </Labeled>
                          <DatePicker
                            selected={toDate}
                            onChange={(date: Date) => {
                              setToDateFilter(
                                moment(date).format("YYYY-MM-DD")
                              );
                              setToDate(date);
                            }}
                            maxDate={new Date()}
                            dateFormat="MMMM d, yyyy"
                            className="customDate"
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                )}
              </CardContent>
            </Card>
          </Grid>
        </SanitizedGrid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Tabs
                value={valueDashboardTab}
                onChange={handleChangeDashboardTab}
                aria-label="Dashboard Commercial Document"
                className={classes.sidePanelTabs}
              >
                <Tab label="Payment List" {...dashboardProps(0)} />
                <Tab label="Overdue List" {...dashboardProps(1)} />
              </Tabs>

              <TabPanel value={valueDashboardTab} index={0}>
                <Grid item xs={12}>
                  <PaymentHistoryTable
                    fromDate={fromDateFilter}
                    toDate={toDateFilter}
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={valueDashboardTab} index={1}>
                <Grid item xs={12}>
                  <InvoiceTable
                    isDueInvoice
                    fromDueDate={fromDateFilter}
                    toDueDate={toDateFilter}
                  />
                </Grid>
              </TabPanel>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Find Invoice / Credit Note Info
          </Typography>

          <FindInvoiceNumberInput />
        </Grid>
      </SanitizedGrid>
    </div>
  );
};

export default DashboardFinance;
